import React, { useEffect,useState } from "react";
import { useSelector, shallowEqual,useDispatch } from "react-redux";
import { fetchSearchResultData } from '../actions/action';
import ListingViewCell from '../../../components/CardListing/listingViewCell';
import CardView from "../../../components/CardListing/cardView";
import ListingComponent from "../../../components/ListingComponent";
import { TOOLTIP_DELAY_TIME } from '../../SpockViewPage/constants';
import { SHOW_TOOLTIP } from '../../../components/Tooltip/constants';
import UserMiniProfile from '../../../components/UserMiniProfile';
import EmptyScreen from '../../../Emptyscreen';
import * as CommonUtil from '../../../common/util';
import { ListingViewConstants } from '../../../common/constants';
import LoaderComponent from '../../../components/Loader';

const Activities = (props) => {
    const { globalSearch } = useSelector(state => ({
        globalSearch: state.header.globalSearch
    }), shallowEqual);

    const dispatch=useDispatch();

    const dataPayload={
        skip: 0,
        take: 100,
        isSearch: true,
        sortDir: 'ASC',
        sortBy: 1,
        rows: 100,
        displayCount: 100,
        status: 'activityassinee',
        _: new Date()
    };

    const [mode, updateMode] = useState({isLandscape:false});

    useEffect(() => {
        const payload={
            ...dataPayload
        };
        payload.key = props.searchString;        
        dispatch(fetchSearchResultData(payload));
        if(CommonUtil.mobileAndTabletcheck() && window.innerHeight < window.innerWidth){
            updateMode({isLandscape:true})
        }  
      }, []);

    const openMiniProfile = (payload) => {
        const { target, userId, type, position, propertylocation, extraData } = payload;
        if (userId) {
            dispatch({
                type: SHOW_TOOLTIP,
                payload: {
                    delay: TOOLTIP_DELAY_TIME,
                    target,
                    position,
                    childComponent: <UserMiniProfile userId={userId} wklocation={propertylocation} extraInfo={extraData}/>,
                }
            });
        }
    }
    const renderListing=()=>{
        const {Data}=globalSearch.activityassinee;
        if(Data.length >0)
        {
            if(!mode.isLandscape && CommonUtil.mobileAndTabletcheck()){
                return <CardView type={"ACTIVITY"} data={{ActivitiesFullData:Data}}  onScrollHandler={onScrollHandler} globalSearch={globalSearch.activeTab} />;
            }
            const prop = {
                data: Data,
                cellTemplate: ListingViewCell,
                onScrollHandler: onScrollHandler,
                onItemClick:false,
                onCellClick:openMiniProfile,
                type:"div",
                selectedId: '',
                classname: 'scrollArea',
                isPagination:false,
                extraData:{selectedids:"",listType:ListingViewConstants.Activity,showCheckbox:false,globalSearch : globalSearch.activeTab}
            }
            return (
                <React.Fragment>
                    <ListingComponent {...prop}/>
                </React.Fragment>
            );
        }
        else{
             return <EmptyScreen name="Emptyowner" type={"assignees"}/>;
}
    }

    const onScrollHandler = () => {
        const { skip, take,Total} = globalSearch.activityassinee;
        const payload={
            ...dataPayload
        };
        payload.key = props.searchString;
        payload.take = (skip === 0 && take > 20 ) ? 20 : parseInt(take);
        payload.skip = (skip === 0 && take > 20 ) ? take : parseInt(skip)+parseInt(take);
        payload.rows = (skip === 0 && take > 20 ) ? 20 : parseInt(take);
        payload.isUpdate = true;
        if(skip+take < Total){
            dispatch(fetchSearchResultData(payload));
        }
    }

    return (
        <div className={`${!mode.isLandscape && CommonUtil.mobileAndTabletcheck() ? '' : 'table'} cardListView scrollArea`}>
            {
                globalSearch.isLoading && !props.showResult && <LoaderComponent/>
            }
            {
                    (globalSearch.activityassinee.Data.length >0 && !CommonUtil.mobileAndTabletcheck())
                    ?
                    <div className="rowFlex tableHead">
                        <ul>
                            <li>Activity Info</li>
                            <li className="">Workkard Info</li>
                            <li className="">Resolution</li>
                            <li className="">Activity Owner</li>
                            <li className="">Activity Assignee</li>
                        </ul>
                    </div>
                    :
                    (mode.isLandscape && globalSearch.activityassinee.Data.length >0) && 
                    <div className="rowFlex tableHead">
                        <ul>
                            <li>Activity Info</li>
                            <li className="">Workkard Info</li>
                            <li className="">Resolution</li>
                            <li className="">Activity Owner</li>
                            <li className="">Activity Assignee</li>
                        </ul>
                    </div>
            }
            <div className={`rowFlex tableBody ${globalSearch.activityassinee.Data.length ==0 ? `noDataFound`:''}`}>
                <div>
                    {
                        globalSearch.activityassinee.status != null &&
                        (
                            globalSearch.activityassinee.status != 200 ?
                            <EmptyScreen name="Errorscreen" onRefreshClick={()=>dispatch(fetchSearchResultData(Object.assign({},dataPayload,{key:props.searchString})))}/>
                            :
                            globalSearch.activeTab==6 && renderListing()
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default Activities;
